import React from 'react';
import {Atom, type AtomRenderProps} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {getChildren} from '@packages/utilities/data-utils';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';

const FormFileUploadDefault = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    data,
    renderChild,
    context,
  }: AtomRenderProps) => {
    const state = context.get('formFileUploadState');
    const updatedClasses = classes.push(
      state === 'default' || state === 'error'
        ? 'w-file-upload-default'
        : 'w-file-upload-default w-hidden'
    );
    return (
      <div {...generateAttributes(attributes, updatedClasses)}>
        {getChildren(data).map((child) => renderChild(child, context))}
      </div>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Default State',
  showEmpty: true,
  constraints: {
    pinToParent: true,
    descendants: [
      {is: 'FormFileUploadInput', rule: 'ExactlyOne'},
      {is: 'FormFileUploadLabel', rule: 'ExactlyOne'},
    ],
  },
  render: FormFileUploadDefault,
  fields: {children: TListOfElement},
});

export default config;
